import type { TRuleWithTheme } from '@/styles/theme';

export const button: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    padding: 0,
    margin: 0,

    color: theme.colors.iconsSecondary,
    background: 'none',
    border: 'none',

    cursor: 'pointer',
});
